import {
    Company,
    PageOptions,
    ProfessionalListProvider,
    UserListProvider,
    UserService,
} from "cw-backend";
import { CwUtils } from "cw-utils";

import { fuseAnimations } from "@fuse/animations";

import { DataSource } from "@angular/cdk/table";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { OverlayContainer } from "@angular/cdk/overlay";
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDatepicker } from "@angular/material/datepicker";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { DomSanitizer } from "@angular/platform-browser";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";
import { CompanyListProvider, DashboardAdminService } from "cw-backend";
import { RolePermissionService } from "cw-services";
import moment from "moment";
import { BehaviorSubject, merge, Observable, Subject } from "rxjs";
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
    takeUntil,
} from "rxjs/operators";
import { DashboardPermissionItem } from "../../../../../../../shared/cw-backend/models/security/restrictable-component-permission";
import { DashboardProvider } from "../dashboard.provider";

interface DashboardTabConfig {
    type: string;
    icon: string;
}

interface DashboardLayoutOption {
    columns: number;
    label: string;
    description: string;
    icon: string;
}

@Component({
    selector: "admin-dashboard",
    templateUrl: "./admin-dashboard.component.html",
    styleUrls: ["./admin-dashboard.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class AdminDashboardComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    @ViewChild("dashboardAdminRoot")
    dashboardAdminRoot!: ElementRef<HTMLElement>;
    @ViewChild("dashboardContentScroll")
    dashboardContentScroll!: ElementRef<HTMLElement>;

    user = JSON.parse(localStorage.getItem("user") || "{}");
    dataSource: any;
    displayedColumns = ["avatar", "name", "date", "ip"];
    refresh: BehaviorSubject<any>;
    users: BehaviorSubject<any>;

    companys: any[];
    tabDashboardList: any[];
    selectedCompany: Company;

    dateNow = Date.now();
    _unsubscribeAll: Subject<any>;

    /* Formulario de Filtros */
    filterForm: FormGroup;

    private initializing = true;

    private readonly dashboardTabConfigByCode: Record<string, DashboardTabConfig> = {
        
        "application-dashboards-admin-schedule": {
            type: "DS",
            icon: "event_note",
        },
        "application-dashboards-admin-reception": {
            type: "RC",
            icon: "support_agent",
        },
        "application-dashboards-admin-order": {
            type: "OS",
            icon: "assignment",
        },
        "application-dashboards-admin-billing": {
            type: "FT",
            icon: "attach_money",
        },
        "application-dashboards-admin-financial": {
            type: "FI",
            icon: "account_balance_wallet",
        },
        "application-dashboards-admin-managerial": {
            type: "GE",
            icon: "assessment",
        },
        "application-dashboards-admin-performer": {
            type: "PF",
            icon: "medical_services",
        },
        "application-dashboards-admin-user": {
            type: "US",
            icon: "groups",
        },
    };

    minDate!: Date;
    maxDate!: Date;

    companyList: any[];
    performerList: any;
    dashboardUserList: any[] = [];

    companyDefault = new Company();

    performerPageOptions: PageOptions;
    companyPageOptions: PageOptions;
    dashboardUserPageOptions: PageOptions;

    filterData: any;
    dashboardPermissions: DashboardPermissionItem[] = [];
    dashboardExpansionCommand = {
        expanded: true,
        version: 0,
    };
    dashboardPanelsExpanded = true;
    globalFiltersVisible = false;
    dashboardPreferenceVisible = false;
    dashboardOrderVisible = false;
    dashboardFullscreen = false;
    dashboardPreferencesLoading = false;
    dashboardPreferencesSaving = false;
    canFilterDashboardOtherUsers = false;
    dashboardFiltersEnabled = true;
    dashboardPreferenceVersion = 0;
    dashboardTabOrderDraft: any[] = [];
    selectedDashboardTabIndex = 0;
    private currentDashboardTabCode = "";
    private readonly managerialDashboardTabCode =
        "application-dashboards-admin-managerial";
    private dashboardPermissionsRequestVersion = 0;
    private companyDefaultApplied = false;
    private filterTargetByTabCode: Record<string, string[]> = {
        "application-dashboards-admin-schedule": ["ALL"],
        "application-dashboards-admin-reception": ["ALL"],
        "application-dashboards-admin-order": ["ALL"],
        "application-dashboards-admin-billing": ["ALL"],
        "application-dashboards-admin-financial": ["ALL"],
        "application-dashboards-admin-managerial": ["ALL"],
    };
    private dashboardPreferenceSelectionByTabCode: Record<string, string[]> = {};
    private dashboardOrderDraftByTabCode: Record<string, string[]> = {};
    private dashboardLayoutDraftByTabCode: Record<
        string,
        Record<string, number>
    > = {};
    readonly dashboardLayoutOptions: DashboardLayoutOption[] = [
        {
            columns: 1,
            label: "Grande",
            description: "1 por linha",
            icon: "crop_16_9",
        },
        {
            columns: 2,
            label: "Medio",
            description: "2 por linha",
            icon: "view_column",
        },
        {
            columns: 3,
            label: "Compacto",
            description: "3 por linha",
            icon: "view_module",
        },
        {
            columns: 4,
            label: "Mini",
            description: "4 por linha",
            icon: "apps",
        },
    ];
    dashboardMonthYearDate = new Date();
    retrictionsFormFields: any;
    private cdkOverlayOriginalParent: HTMLElement | null = null;
    private readonly fullscreenChangeListener = () => {
        this.dashboardFullscreen =
            this.getFullscreenElement() === this.dashboardAdminRoot?.nativeElement;

        if (this.dashboardFullscreen) {
            this.moveOverlayContainerToDashboard();
        } else {
            this.restoreOverlayContainer();
        }

        this.scheduleScrollToActiveTabContent();
    };

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private adminService: DashboardAdminService,
        private companyListProvider: CompanyListProvider,
        private performerListProvider: ProfessionalListProvider,
        private userListProvider: UserListProvider,
        private rolePermissionService: RolePermissionService,
        private userService: UserService,
        private dashboardProvider: DashboardProvider,
        private overlayContainer: OverlayContainer,
        private _sanitizer: DomSanitizer,
        private cwUtils: CwUtils,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
        this.performerPageOptions = new PageOptions();
        this.companyPageOptions = new PageOptions();
        this.dashboardUserPageOptions = new PageOptions();
        this.dashboardUserPageOptions.fieldSort = "login";
        this.selectedCompany = new Company();
        this.refresh = new BehaviorSubject<any>(false);
        this.users = new BehaviorSubject([{}]);
        this._unsubscribeAll = new Subject();

        setInterval(() => {
            this.dateNow = Date.now();
        }, 1000);

        this.filterForm = new FormGroup({
            filterTarget: new FormControl(["ALL"]),
            startDate: new FormControl(null),
            endDate: new FormControl(null),
            dashboardMonth: new FormControl(null),
            dashboardYear: new FormControl(null),
            company: new FormControl(null),
            performer: new FormControl(null),
            user: new FormControl(null),
        });

        this.setCurrentMonthToDateRange();
        this.setCurrentDashboardMonthYear();
    }
    ngAfterViewInit(): void {
        this.scheduleScrollToActiveTabContent(450);
    }

    getDashboardsAndPermissions(type: string): Promise<void> {
        const requestVersion = ++this.dashboardPermissionsRequestVersion;

        this.dashboardPermissions = [];

        return this.dashboardProvider
            .getDashboardsAndPermissions("application-dashboards-admin", type)
            .then(async (res) => {
                const currentType =
                    this.dashboardTabConfigByCode[this.currentDashboardTabCode]
                        ?.type;

                if (
                    requestVersion !== this.dashboardPermissionsRequestVersion ||
                    currentType !== type
                ) {
                    return;
                }

                const permissions = this.getResponsePayload(res);

                this.dashboardPermissions = Array.isArray(permissions)
                    ? permissions
                    : [];
                this.initializing = false;
                this.restoreFilterTargetForCurrentTab();
                this.applyDefaultCompanyForCurrentTab();
                this.updateFilterData();

                if (this.dashboardPreferenceVisible || this.dashboardOrderVisible) {
                    await this.loadDashboardPreferencesForCurrentTab();
                }

                this.scheduleScrollToActiveTabContent();
            });
    }

    ngOnInit(): void {
        this.initializing = true;
        document.addEventListener(
            "fullscreenchange",
            this.fullscreenChangeListener,
        );

        if (this.user.company) {
            this.getCompanyById(this.user.company);
        } else {
            this.getAllDashboards();
        }

        this.adminService.getUsers().then((res) => {
            let users = res.body;
            users?.forEach((user) => {
                if (user.photo) {
                    user.photo = this._sanitizer.bypassSecurityTrustResourceUrl(
                        "data:image/jpg;base64," + user.photo,
                    );
                }
            });
            this.users.next(res.body);
            this.dataSource = users;
        });

        this.getDashboardFeaturePermissions();
        this.getPerformerList();
        this.getCompany(true);
        this.getDashboardUserList();
        this.filterPerformer();
        this.filterCompany();
        this.filterDashboardUser();
        this.filtersDashboard();
    }

    ngOnDestroy(): void {
        document.removeEventListener(
            "fullscreenchange",
            this.fullscreenChangeListener,
        );
        this.restoreOverlayContainer();
        this.unlockDashboardModalScroll(true);
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    private setCurrentMonthToDateRange(): void {
        const now = new Date();

        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        start.setHours(0, 0, 0, 0);

        const end = new Date(now);
        end.setHours(23, 59, 59, 999);

        this.filterForm.get("startDate")?.setValue(start, { emitEvent: false });
        this.filterForm.get("endDate")?.setValue(end, { emitEvent: false });
    }

    private setCurrentDashboardMonthYear(): void {
        const previousMonth = this.getPreviousDashboardMonthDate();
        this.dashboardMonthYearDate = previousMonth;

        this.filterForm
            .get("dashboardMonth")
            ?.setValue(previousMonth.getMonth() + 1, {
                emitEvent: false,
            });
        this.filterForm
            .get("dashboardYear")
            ?.setValue(previousMonth.getFullYear(), {
                emitEvent: false,
            });
    }

    private getPreviousDashboardMonthDate(): Date {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth() - 1, 1);
    }

    setDashboardMonthAndYear(
        selectedMonthAndYear: any,
        datepicker?: MatDatepicker<any>,
    ): void {
        const selectedDate = this.normalizeDashboardMonthYearDate(
            selectedMonthAndYear,
        );

        this.dashboardMonthYearDate = selectedDate;
        this.filterForm.patchValue({
            dashboardMonth: selectedDate.getMonth() + 1,
            dashboardYear: selectedDate.getFullYear(),
        });

        if (datepicker) {
            datepicker.close();
        }
    }

    getDashboardMonthYearDisplay(): string {
        const month =
            Number(this.filterForm.get("dashboardMonth")?.value) ||
            this.dashboardMonthYearDate.getMonth() + 1;
        const year =
            Number(this.filterForm.get("dashboardYear")?.value) ||
            this.dashboardMonthYearDate.getFullYear();

        return `${String(month).padStart(2, "0")}/${year}`;
    }

    private normalizeDashboardMonthYearDate(value: any): Date {
        if (
            value &&
            typeof value.month === "function" &&
            typeof value.year === "function"
        ) {
            return new Date(value.year(), value.month(), 1);
        }

        const date = value instanceof Date ? value : new Date(value);

        if (!isNaN(date.getTime())) {
            return new Date(date.getFullYear(), date.getMonth(), 1);
        }

        return this.getPreviousDashboardMonthDate();
    }

    getDashboardPermissions() {
        this.adminService
            .getDashboardByUserRolePermission(this.user.id)
            .then((res) => {
                this.tabDashboardList = res.body;
                this.resetDashboardTabOrderDraft();
                this.ensureSelectedDashboardTab();
                console.log(this.tabDashboardList);
                this.scheduleScrollToActiveTabContent(250);
            });
    }

    async getDashboardFeaturePermissions(): Promise<void> {
        try {
            const res =
                await this.dashboardProvider.getDashboardFeaturePermissions();
            const permissions = this.getResponsePayload(res) || {};

            this.canFilterDashboardOtherUsers =
                !!permissions.canFilterOtherUsers;
            this.dashboardFiltersEnabled = !!permissions.filtersEnabled;

            if (this.canFilterDashboardOtherUsers) {
                this.filterForm.get("user")?.setValue(null, {
                    emitEvent: false,
                });
            }
        } catch {
            this.canFilterDashboardOtherUsers = false;
            this.dashboardFiltersEnabled = true;
        }

        this.applyDashboardFunctionalPermissions();
    }

    getDate(accessDate) {
        moment.locale("pt-br");
        return moment(accessDate).calendar();
    }

    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    filtersDashboard() {
        this.filterForm
            .get("performer")
            ?.valueChanges.pipe(
                debounceTime(400),
                distinctUntilChanged(),
                filter((value) => typeof value !== "string"),
            )
            .subscribe(() => {
                if (this.initializing) return;
                //this.getAllDashboards();
            });

        this.filterForm
            .get("company")
            ?.valueChanges.pipe(
                debounceTime(400),
                distinctUntilChanged(),
                filter((value) => typeof value !== "string"),
            )
            .subscribe(() => {
                if (this.initializing) return;
                //this.getAllDashboards();
            });

        this.filterForm
            .get("filterTarget")
            ?.valueChanges.pipe(debounceTime(200))
            .subscribe((value) => {
                if (this.initializing) return;

                const arr: string[] = Array.isArray(value) ? value : [];

                if (arr.includes("ALL") && arr.length > 1) {
                    this.filterForm.get("filterTarget")?.setValue(["ALL"], {
                        emitEvent: false,
                    });
                    return;
                }
            });
    }

    displayCompanyFn(company?: any): string | undefined {
        if (!company) {
            return "";
        }
        if (company.name) {
            return company.name;
        }
        return company.name;
    }

    displayFn(performer?: any): string | undefined {
        if (
            performer &&
            performer.professional &&
            performer.professional.person.name
        ) {
            return performer.professional.person.name;
        } else if (performer && performer.person) {
            return performer.person.name;
        }
        return "";
    }

    displayDashboardUserFn = (user?: any): string => {
        return this.getDashboardUserName(user);
    };

    getDashboardUserName(user?: any): string {
        if (!user) {
            return "";
        }

        return (
            user.person?.name ||
            user.professional?.person?.name ||
            user.name ||
            user.username ||
            user.login ||
            user.email ||
            ""
        );
    }

    performerSelected(ev: any) {
        const performer = ev.option.value;
        //this.getAllDashboards();
    }

    companySelected(ev: any) {
        const company = ev.option.value;
        this.companyDefaultApplied = false;
        //this.getAllDashboards();
    }

    clearAll() {
        this.filterForm.get("filterTarget")?.setValue(["ALL"]);
        this.setCurrentMonthToDateRange();
        this.setCurrentDashboardMonthYear();
        this.filterForm.get("performer")?.setValue(null);
        this.filterForm.get("company")?.setValue(null);
        this.companyDefaultApplied = false;
        if (this.canFilterDashboardOtherUsers) {
            this.filterForm.get("user")?.setValue(null);
        } else {
            this.setCurrentDashboardUserFilter();
        }
    }

    clearDateRange(): void {
        this.filterForm.get("startDate")?.setValue(null);
        this.filterForm.get("endDate")?.setValue(null);
    }

    getCompanyById(id: number) {
        this.companyListProvider.get(id).subscribe((res) => {
            this.companyDefault = res.body;
            this.filterForm.get("company")?.setValue(this.companyDefault, {
                emitEvent: false,
            });
            this.companyDefaultApplied = true;
            this.applyDefaultCompanyForCurrentTab();
            this.getAllDashboards();
        });
    }

    getCompany(loadDashboardPermissions = false) {
        this.companyListProvider
            .getPageSimpleList(this.companyPageOptions)
            .then((res) => {
                this.companyList = res.body.content;

                this.companys = res.body;
                this.selectedCompany = res.body[0];

                if (loadDashboardPermissions) {
                    this.getDashboardPermissions();
                }
            });
    }

    filterCompany() {
        this.filterForm
            .get("company")
            ?.valueChanges.pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res && res.id) {
                    this.companyPageOptions.argument = res.name;
                } else if (res && typeof res === "string") {
                    this.companyPageOptions.argument = res;
                } else {
                    this.companyPageOptions.argument = "";
                }

                this.getCompany();
            });
    }

    getDashboardUserList(applyFunctionalPermissions = true) {
        this.userListProvider
            .getPageUserSimpleList(this.dashboardUserPageOptions)
            .then((res) => {
                this.dashboardUserList = this.normalizeDashboardUsers(
                    res.body?.content || [],
                );

                if (applyFunctionalPermissions) {
                    this.applyDashboardFunctionalPermissions();
                }
            });
    }

    filterDashboardUser() {
        this.filterForm
            .get("user")
            ?.valueChanges.pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res && this.getDashboardUserId(res)) {
                    this.dashboardUserPageOptions.argument =
                        this.getDashboardUserName(res);
                } else if (res && typeof res === "string") {
                    this.dashboardUserPageOptions.argument = res;
                } else {
                    this.dashboardUserPageOptions.argument = "";
                }

                this.getDashboardUserList(false);
            });
    }

    getPerformerList() {
        this.performerPageOptions.fieldSort = "professional.person.name";

        this.performerListProvider
            .getPerformerAllPageNoEntity(this.performerPageOptions)
            .then((res) => {
                this.performerList = res.body.content;
                console.log(this.performerList);
                //this.performerCtrl.setValue(this.performerList[0]);
            });
    }

    filterPerformer() {
        this.filterForm
            .get("performer")
            ?.valueChanges.pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res.name) {
                } else if (res.professional) {
                    this.performerPageOptions.argument =
                        res.professional.person.name;
                } else if (res) {
                    this.performerPageOptions.argument = res;
                } else {
                    this.performerPageOptions.argument = "";
                }
                this.getPerformerList();
            });
    }

    getAllDashboards() {
        this.filterData = this.filterForm.getRawValue();

        console.log(
            "🚀 ~ AdminDashboardComponent ~ getAllDashboards ~ data:",
            this.filterData,
        );
    }

    setupFilterTargetListener(): void {
        this.filterForm
            .get("filterTarget")
            ?.valueChanges.pipe(debounceTime(200))
            .subscribe((value) => {
                if (this.initializing) return;

                const arr: string[] = Array.isArray(value) ? value : [];

                if (arr.includes("ALL") && arr.length > 1) {
                    this.filterForm.get("filterTarget")?.setValue(["ALL"], {
                        emitEvent: false,
                    });
                    return;
                }
            });
    }

    updateFilterData(): void {
        this.filterData = {
            ...this.filterForm.getRawValue(),
            dashboardPreferenceVersion: this.dashboardPreferenceVersion,
        };
    }

    get canSelectDashboardUserFilter(): boolean {
        return this.dashboardFiltersEnabled && this.canFilterDashboardOtherUsers;
    }

    get availableDashboardPermissions(): DashboardPermissionItem[] {
        return this.dashboardPermissions.filter(
            (item) => item.restrictionType !== "H",
        );
    }

    getGlobalFilterSummary(): string {
        if (!this.dashboardFiltersEnabled) {
            return "Filtros desabilitados pelo perfil";
        }

        const appliedFilters = this.filterData || this.filterForm.getRawValue();
        const target = appliedFilters.filterTarget;
        const targetCount = Array.isArray(target)
            ? target.includes("ALL")
                ? "todos"
                : `${target.length || 0} selecionado(s)`
            : "nenhum";
        const startDate = appliedFilters.startDate;
        const endDate = appliedFilters.endDate;
        const hasPeriod = !!startDate || !!endDate;
        const company = appliedFilters.company;
        const performer = appliedFilters.performer;
        const dashboardUser = appliedFilters.user;
        const dashboardMonth = appliedFilters.dashboardMonth;
        const dashboardYear = appliedFilters.dashboardYear;
        const activeFilters = [
            hasPeriod,
            !!dashboardMonth && !!dashboardYear,
            !!company,
            !!performer,
            !!dashboardUser,
            targetCount !== "todos",
        ].filter(Boolean).length;

        return activeFilters
            ? `${activeFilters} filtro(s) ativo(s) · ${targetCount}`
            : `Sem filtro geral · ${targetCount}`;
    }

    get userDisplayName(): string {
        const name =
            this.user?.person?.name ||
            this.user?.professional?.person?.name ||
            this.user?.name ||
            this.user?.username ||
            this.user?.login ||
            this.user?.email;

        if (!name) {
            return "usuário";
        }

        return name.toString().split(" ").filter(Boolean).slice(0, 2).join(" ");
    }

    openGlobalFilters(): void {
        if (!this.dashboardFiltersEnabled) {
            return;
        }

        this.restoreGlobalFilterDraft();
        this.globalFiltersVisible = true;
        this.lockDashboardModalScroll();
    }

    closeGlobalFilters(): void {
        this.restoreGlobalFilterDraft();
        this.globalFiltersVisible = false;
        this.unlockDashboardModalScroll();
    }

    applyGlobalFilters(): void {
        const target = this.filterForm.get("filterTarget")?.value;
        const normalizedTarget =
            Array.isArray(target) && target.length && !target.includes("ALL")
                ? target
                : ["ALL"];

        this.filterForm.get("filterTarget")?.setValue(normalizedTarget, {
            emitEvent: false,
        });
        this.saveFilterTargetForCurrentTab(normalizedTarget);
        this.updateFilterData();
        this.globalFiltersVisible = false;
        this.unlockDashboardModalScroll();
    }

    private restoreGlobalFilterDraft(): void {
        const appliedFilters = this.getAppliedGlobalFilters();

        this.filterForm.patchValue(appliedFilters, { emitEvent: false });

        if (appliedFilters.dashboardMonth && appliedFilters.dashboardYear) {
            this.dashboardMonthYearDate = this.normalizeDashboardMonthYearDate(
                new Date(
                    Number(appliedFilters.dashboardYear),
                    Number(appliedFilters.dashboardMonth) - 1,
                    1,
                ),
            );
        } else {
            this.setCurrentDashboardMonthYear();
        }
    }

    private getAppliedGlobalFilters(): any {
        return {
            filterTarget: this.filterData?.filterTarget || ["ALL"],
            startDate: this.filterData?.startDate || null,
            endDate: this.filterData?.endDate || null,
            dashboardMonth: this.filterData?.dashboardMonth || null,
            dashboardYear: this.filterData?.dashboardYear || null,
            company: this.filterData?.company || null,
            performer: this.filterData?.performer || null,
            user: this.filterData?.user || null,
        };
    }

    private applyDashboardFunctionalPermissions(): void {
        const userControl = this.filterForm.get("user");

        if (!userControl) {
            return;
        }

        if (this.canFilterDashboardOtherUsers) {
            if (this.dashboardFiltersEnabled) {
                userControl.enable({ emitEvent: false });
            } else {
                userControl.disable({ emitEvent: false });
            }
        } else {
            this.setCurrentDashboardUserFilter();
            userControl.disable({ emitEvent: false });
        }

        if (!this.dashboardFiltersEnabled && this.globalFiltersVisible) {
            this.globalFiltersVisible = false;
            this.unlockDashboardModalScroll();
        }

        this.updateFilterData();
    }

    private setCurrentDashboardUserFilter(): void {
        const currentUser = this.getCurrentDashboardUserOption();

        this.filterForm.get("user")?.setValue(currentUser, {
            emitEvent: false,
        });
    }

    private getCurrentDashboardUserOption(): any {
        const currentUserId = this.getDashboardUserId(this.user);
        const foundUser = (this.dashboardUserList || []).find(
            (user) => this.getDashboardUserId(user) === currentUserId,
        );

        return foundUser || this.user;
    }

    private normalizeDashboardUsers(users: any[]): any[] {
        const normalizedUsers = Array.isArray(users) ? [...users] : [];
        const currentUserId = this.getDashboardUserId(this.user);
        const hasCurrentUser = normalizedUsers.some(
            (user) => this.getDashboardUserId(user) === currentUserId,
        );

        if (currentUserId && !hasCurrentUser) {
            normalizedUsers.unshift(this.user);
        }

        return normalizedUsers;
    }

    private getDashboardUserId(user?: any): any {
        return user?.id || user?.userId || user?.user_id || user?.user?.id;
    }

    get isDashboardModalOpen(): boolean {
        return (
            this.globalFiltersVisible ||
            this.dashboardPreferenceVisible ||
            this.dashboardOrderVisible
        );
    }

    blockDashboardModalScroll(event: Event): void {
        const target = event.target as HTMLElement;

        if (target?.closest(".dashboard-filter-modal")) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
    }

    private lockDashboardModalScroll(): void {
        document.body.classList.add("dashboard-modal-open");
    }

    private unlockDashboardModalScroll(force = false): void {
        if (force) {
            document.body.classList.remove("dashboard-modal-open");
            return;
        }

        if (
            this.globalFiltersVisible ||
            this.dashboardPreferenceVisible ||
            this.dashboardOrderVisible
        ) {
            return;
        }

        document.body.classList.remove("dashboard-modal-open");
    }

    expandAllDashboards(): void {
        this.dashboardPanelsExpanded = true;
        this.dashboardExpansionCommand = {
            expanded: true,
            version: this.dashboardExpansionCommand.version + 1,
        };
    }

    collapseAllDashboards(): void {
        this.dashboardPanelsExpanded = false;
        this.dashboardExpansionCommand = {
            expanded: false,
            version: this.dashboardExpansionCommand.version + 1,
        };
    }

    onTabChange(event: MatTabChangeEvent): void {
        const selectedTab = this.tabDashboardList?.[event.index];

        if (!selectedTab) {
            return;
        }

        this.selectedDashboardTabIndex = event.index;
        this.saveFilterTargetForCurrentTab(
            this.filterForm.get("filterTarget")?.value,
        );
        this.currentDashboardTabCode = selectedTab.code;
        this.restoreFilterTargetForCurrentTab();
        this.applyDefaultCompanyForCurrentTab();
        this.updateFilterData();

        const tabConfig = this.dashboardTabConfigByCode[selectedTab.code];

        if (tabConfig) {
            this.getDashboardsAndPermissions(tabConfig.type);
        }

        this.scheduleScrollToActiveTabContent(350);
    }

    private ensureSelectedDashboardTab(): void {
        const tabs = this.tabDashboardList || [];

        if (!tabs.length) {
            this.selectedDashboardTabIndex = 0;
            return;
        }

        let selectedIndex = tabs.findIndex(
            (tab) => tab.code === this.currentDashboardTabCode,
        );

        if (selectedIndex < 0) {
            selectedIndex = 0;
            this.currentDashboardTabCode = tabs[0].code;
        }

        this.selectedDashboardTabIndex = selectedIndex;
        this.restoreFilterTargetForCurrentTab();
        this.applyDefaultCompanyForCurrentTab();

        const tabConfig = this.dashboardTabConfigByCode[this.currentDashboardTabCode];

        if (tabConfig) {
            this.getDashboardsAndPermissions(tabConfig.type);
        }
    }

    private applyDefaultCompanyForCurrentTab(): void {
        if (
            !this.companyDefaultApplied ||
            this.currentDashboardTabCode !== this.managerialDashboardTabCode
        ) {
            return;
        }

        const companyControl = this.filterForm.get("company");
        const company = companyControl?.value;

        if (!company || !this.isSameCompany(company, this.companyDefault)) {
            return;
        }

        companyControl?.setValue(null, { emitEvent: false });
        this.companyDefaultApplied = false;
    }

    private isSameCompany(companyA?: any, companyB?: any): boolean {
        const companyAId =
            companyA?.id || companyA?.companyId || companyA?.company_id;
        const companyBId =
            companyB?.id || companyB?.companyId || companyB?.company_id;

        return !!companyAId && !!companyBId && companyAId === companyBId;
    }

    async toggleDashboardFullscreen(): Promise<void> {
        if (this.dashboardFullscreen) {
            await this.exitDashboardFullscreen();
            return;
        }

        const element = this.dashboardAdminRoot?.nativeElement as any;
        const requestFullscreen =
            element?.requestFullscreen ||
            element?.webkitRequestFullscreen ||
            element?.msRequestFullscreen;

        try {
            if (requestFullscreen) {
                await requestFullscreen.call(element);
            } else {
                this.dashboardFullscreen = true;
                this.moveOverlayContainerToDashboard();
            }
        } catch {
            this.dashboardFullscreen = true;
            this.moveOverlayContainerToDashboard();
        }

        this.scheduleScrollToActiveTabContent();
    }

    private async exitDashboardFullscreen(): Promise<void> {
        const doc = document as any;
        const exitFullscreen =
            document.exitFullscreen ||
            doc.webkitExitFullscreen ||
            doc.msExitFullscreen;

        try {
            if (this.getFullscreenElement() && exitFullscreen) {
                await exitFullscreen.call(document);
            } else {
                this.dashboardFullscreen = false;
                this.restoreOverlayContainer();
            }
        } catch {
            this.dashboardFullscreen = false;
            this.restoreOverlayContainer();
        }

        this.scheduleScrollToActiveTabContent();
    }

    private getFullscreenElement(): Element | null {
        const doc = document as any;

        return (
            document.fullscreenElement ||
            doc.webkitFullscreenElement ||
            doc.msFullscreenElement ||
            null
        );
    }

    private moveOverlayContainerToDashboard(): void {
        const dashboard = this.dashboardAdminRoot?.nativeElement;
        const overlayContainer = this.overlayContainer.getContainerElement();

        if (
            !dashboard ||
            !overlayContainer ||
            overlayContainer.parentElement === dashboard
        ) {
            return;
        }

        this.cdkOverlayOriginalParent =
            overlayContainer.parentElement as HTMLElement;
        dashboard.appendChild(overlayContainer);
    }

    private restoreOverlayContainer(): void {
        const overlayContainer = this.overlayContainer.getContainerElement();
        const originalParent = this.cdkOverlayOriginalParent || document.body;

        if (
            overlayContainer &&
            overlayContainer.parentElement !== originalParent
        ) {
            originalParent.appendChild(overlayContainer);
        }

        this.cdkOverlayOriginalParent = null;
    }

    private scheduleScrollToActiveTabContent(delay = 120): void {
        setTimeout(() => this.scrollToActiveTabContent(), delay);
    }

    private scrollToActiveTabContent(): void {
        const container = this.dashboardContentScroll?.nativeElement;

        if (!container) {
            return;
        }

        const anchor =
            (container.querySelector(
                ".mat-tab-body-active .dashboard-tab-content-anchor",
            ) as HTMLElement) ||
            (container.querySelector(
                ".dashboard-tab-content-anchor",
            ) as HTMLElement);

        if (!anchor) {
            return;
        }

        const sticky = container.querySelector(
            ".dashboard-filter-sticky",
        ) as HTMLElement;
        const containerRect = container.getBoundingClientRect();
        const anchorRect = anchor.getBoundingClientRect();
        const stickyHeight = sticky?.offsetHeight || 0;
        const targetTop =
            container.scrollTop + anchorRect.top - containerRect.top - stickyHeight - 8;

        container.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: "smooth",
        });
    }

    private saveFilterTargetForCurrentTab(value: any): void {
        if (!this.currentDashboardTabCode) {
            return;
        }

        this.filterTargetByTabCode[this.currentDashboardTabCode] =
            Array.isArray(value) ? [...value] : [];
    }

    private restoreFilterTargetForCurrentTab(): void {
        const value = this.filterTargetByTabCode[this.currentDashboardTabCode] || [
            "ALL",
        ];

        this.filterForm.get("filterTarget")?.setValue([...value], {
            emitEvent: false,
        });
    }

    async openDashboardPreferences(): Promise<void> {
        const tabConfig = this.dashboardTabConfigByCode[this.currentDashboardTabCode];

        this.dashboardPreferenceVisible = true;
        this.lockDashboardModalScroll();

        if (tabConfig && !this.availableDashboardPermissions.length) {
            await this.getDashboardsAndPermissions(tabConfig.type);
        }

        await this.loadDashboardPreferencesForCurrentTab();
    }

    closeDashboardPreferences(): void {
        if (this.dashboardPreferencesSaving) {
            return;
        }

        this.dashboardPreferenceVisible = false;
        this.unlockDashboardModalScroll();
    }

    async openDashboardOrder(): Promise<void> {
        const tabConfig = this.dashboardTabConfigByCode[this.currentDashboardTabCode];

        this.dashboardOrderVisible = true;
        this.lockDashboardModalScroll();

        if (tabConfig && !this.availableDashboardPermissions.length) {
            await this.getDashboardsAndPermissions(tabConfig.type);
            return;
        }

        await this.loadDashboardPreferencesForCurrentTab();
        await this.loadDashboardTabPreferences();
        this.resetDashboardOrderDraft();
    }

    closeDashboardOrder(): void {
        if (this.dashboardPreferencesSaving) {
            return;
        }

        this.dashboardOrderVisible = false;
        this.unlockDashboardModalScroll();
    }

    async loadDashboardPreferencesForCurrentTab(): Promise<void> {
        const tabConfig = this.dashboardTabConfigByCode[this.currentDashboardTabCode];

        if (!tabConfig) {
            return;
        }

        this.dashboardPreferencesLoading = true;

        try {
            const res =
                await this.dashboardProvider.getDashboardReportPreferences(
                    tabConfig.type,
                );
            const preference = this.getResponsePayload(res);
            const permittedCodes = this.availableDashboardPermissions.map(
                (item) => item.code,
            );
            const selectedCodes = Array.isArray(preference?.dashboardCodes)
                ? preference.dashboardCodes
                : permittedCodes;
            const layoutColumnsByCode = this.normalizeDashboardLayoutColumns(
                preference?.dashboardLayoutColumnsByCode,
                permittedCodes,
            );

            this.dashboardPreferenceSelectionByTabCode[
                this.currentDashboardTabCode
            ] = selectedCodes.filter((code) => permittedCodes.includes(code));
            this.dashboardLayoutDraftByTabCode[this.currentDashboardTabCode] =
                layoutColumnsByCode;
            this.resetDashboardOrderDraft();
        } finally {
            this.dashboardPreferencesLoading = false;
        }
    }

    get dashboardPreferenceSelection(): string[] {
        return (
            this.dashboardPreferenceSelectionByTabCode[
                this.currentDashboardTabCode
            ] || []
        );
    }

    isDashboardPreferenceSelected(code: string): boolean {
        return this.dashboardPreferenceSelection.includes(code);
    }

    toggleDashboardPreferenceItem(code: string): void {
        if (this.dashboardPreferencesSaving) {
            return;
        }

        this.toggleDashboardPreference(
            code,
            !this.isDashboardPreferenceSelected(code),
        );
    }

    toggleDashboardPreference(code: string, selected: boolean): void {
        const current = new Set(this.dashboardPreferenceSelection);

        if (selected) {
            current.add(code);
        } else {
            current.delete(code);
        }

        this.dashboardPreferenceSelectionByTabCode[
            this.currentDashboardTabCode
        ] = Array.from(current);
        this.ensureDashboardLayoutDraft();
    }

    selectAllDashboardPreferences(): void {
        this.dashboardPreferenceSelectionByTabCode[
            this.currentDashboardTabCode
        ] = this.availableDashboardPermissions.map((item) => item.code);
        this.ensureDashboardLayoutDraft();
    }

    clearDashboardPreferences(): void {
        this.dashboardPreferenceSelectionByTabCode[
            this.currentDashboardTabCode
        ] = [];
        this.ensureDashboardLayoutDraft();
    }

    get dashboardOrderDraft(): string[] {
        return (
            this.dashboardOrderDraftByTabCode[this.currentDashboardTabCode] || []
        );
    }

    get orderedDashboardPreferenceItems(): DashboardPermissionItem[] {
        const itemsByCode = new Map(
            this.availableDashboardPermissions.map((item) => [item.code, item]),
        );

        return this.dashboardOrderDraft
            .map((code) => itemsByCode.get(code))
            .filter((item): item is DashboardPermissionItem => !!item);
    }

    get hiddenDashboardPreferenceCount(): number {
        return Math.max(
            this.availableDashboardPermissions.length -
                this.dashboardOrderDraft.length,
            0,
        );
    }

    async loadDashboardTabPreferences(): Promise<void> {
        if (!this.tabDashboardList?.length) {
            this.dashboardTabOrderDraft = [];
            return;
        }

        const res = await this.dashboardProvider.getDashboardTabPreferences();
        const preference = this.getResponsePayload(res);
        const permittedTabs = [...this.tabDashboardList];
        const permittedByCode = new Map(
            permittedTabs.map((tab) => [tab.code, tab]),
        );
        const preferredCodes = Array.isArray(preference?.tabCodes)
            ? preference.tabCodes
            : permittedTabs.map((tab) => tab.code);
        const preferredSet = new Set(preferredCodes);

        this.dashboardTabOrderDraft = [
            ...preferredCodes
                .map((code) => permittedByCode.get(code))
                .filter((tab) => !!tab),
            ...permittedTabs.filter((tab) => !preferredSet.has(tab.code)),
        ];
    }

    resetDashboardTabOrderDraft(): void {
        this.dashboardTabOrderDraft = [...(this.tabDashboardList || [])];
    }

    private applyDashboardTabOrder(tabCodes: string[]): void {
        const tabs = [...(this.tabDashboardList || [])];
        const tabsByCode = new Map(tabs.map((tab) => [tab.code, tab]));
        const orderedCodes = Array.isArray(tabCodes) ? tabCodes : [];
        const orderedSet = new Set(orderedCodes);
        const currentTabCode = this.currentDashboardTabCode;
        const orderedTabs = [
            ...orderedCodes
                .map((code) => tabsByCode.get(code))
                .filter((tab) => !!tab),
            ...tabs.filter((tab) => !orderedSet.has(tab.code)),
        ];

        this.tabDashboardList = [];
        this.selectedDashboardTabIndex = 0;
        this.changeDetectorRef.detectChanges();

        this.tabDashboardList = orderedTabs;
        this.selectedDashboardTabIndex = Math.max(
            this.tabDashboardList.findIndex(
                (tab) => tab.code === currentTabCode,
            ),
            0,
        );
        this.currentDashboardTabCode =
            this.tabDashboardList[this.selectedDashboardTabIndex]?.code ||
            currentTabCode;
        this.resetDashboardTabOrderDraft();
        this.changeDetectorRef.detectChanges();
    }

    dropDashboardTabOrder(event: CdkDragDrop<any[]>): void {
        if (this.dashboardPreferencesSaving) {
            return;
        }

        const current = [...this.dashboardTabOrderDraft];
        moveItemInArray(current, event.previousIndex, event.currentIndex);
        this.dashboardTabOrderDraft = current;
    }

    dropDashboardOrder(event: CdkDragDrop<string[]>): void {
        if (this.dashboardPreferencesSaving) {
            return;
        }

        const current = [...this.dashboardOrderDraft];
        moveItemInArray(current, event.previousIndex, event.currentIndex);
        this.dashboardOrderDraftByTabCode[this.currentDashboardTabCode] = current;
    }

    resetDashboardOrderDraft(): void {
        const selectedCodes = this.dashboardPreferenceSelection;
        const permittedCodes = this.availableDashboardPermissions.map(
            (item) => item.code,
        );
        const selectedSet = new Set(selectedCodes);
        const orderedCodes = [
            ...selectedCodes.filter((code) => permittedCodes.includes(code)),
            ...permittedCodes.filter((code) => !selectedSet.has(code)),
        ];

        this.dashboardOrderDraftByTabCode[this.currentDashboardTabCode] =
            orderedCodes.filter((code) => selectedSet.has(code));
        this.ensureDashboardLayoutDraft();
    }

    async saveDashboardOrder(): Promise<void> {
        const tabConfig = this.dashboardTabConfigByCode[this.currentDashboardTabCode];

        if (!tabConfig) {
            return;
        }

        this.dashboardPreferencesSaving = true;

        try {
            const tabPreferenceResponse =
                await this.dashboardProvider.saveDashboardTabPreferences(
                    this.dashboardTabOrderDraft.map((tab) => tab.code),
                );
            const tabPreference = this.getResponsePayload(tabPreferenceResponse);

            if (Array.isArray(tabPreference?.tabCodes)) {
                this.applyDashboardTabOrder(tabPreference.tabCodes);
            } else {
                this.applyDashboardTabOrder(
                    this.dashboardTabOrderDraft.map((tab) => tab.code),
                );
            }

            const res =
                await this.dashboardProvider.saveDashboardReportPreferences(
                    tabConfig.type,
                    this.dashboardOrderDraft,
                    this.getDashboardLayoutColumnsPayload(),
                );
            const preference = this.getResponsePayload(res);

            if (Array.isArray(preference?.dashboardCodes)) {
                this.dashboardPreferenceSelectionByTabCode[
                    this.currentDashboardTabCode
                ] = preference.dashboardCodes;
            } else {
                this.dashboardPreferenceSelectionByTabCode[
                    this.currentDashboardTabCode
                ] = [...this.dashboardOrderDraft];
            }

            this.resetDashboardOrderDraft();
            this.filterForm.get("filterTarget")?.setValue(["ALL"], {
                emitEvent: false,
            });
            this.saveFilterTargetForCurrentTab(["ALL"]);
            this.dashboardPreferenceVersion += 1;
            this.updateFilterData();
            this.dashboardOrderVisible = false;
            this.unlockDashboardModalScroll();
            this.ensureSelectedDashboardTab();
        } finally {
            this.dashboardPreferencesSaving = false;
        }
    }

    async saveDashboardPreferences(): Promise<void> {
        const tabConfig = this.dashboardTabConfigByCode[this.currentDashboardTabCode];

        if (!tabConfig) {
            return;
        }

        this.dashboardPreferencesSaving = true;

        try {
            const res =
                await this.dashboardProvider.saveDashboardReportPreferences(
                    tabConfig.type,
                    this.dashboardPreferenceSelection,
                    this.getDashboardLayoutColumnsPayload(),
                    true,
                );
            const preference = this.getResponsePayload(res);

            if (Array.isArray(preference?.dashboardCodes)) {
                this.dashboardPreferenceSelectionByTabCode[
                    this.currentDashboardTabCode
                ] = preference.dashboardCodes;
            }

            this.filterForm.get("filterTarget")?.setValue(["ALL"], {
                emitEvent: false,
            });
            this.saveFilterTargetForCurrentTab(["ALL"]);
            this.dashboardPreferenceVersion += 1;
            this.updateFilterData();
            this.dashboardPreferenceVisible = false;
            this.unlockDashboardModalScroll();
        } finally {
            this.dashboardPreferencesSaving = false;
        }
    }

    get dashboardLayoutDraft(): Record<string, number> {
        return (
            this.dashboardLayoutDraftByTabCode[this.currentDashboardTabCode] || {}
        );
    }

    getDashboardLayoutColumns(code: string): number {
        return Math.min(
            this.normalizeDashboardLayoutColumn(this.dashboardLayoutDraft[code]),
            this.getMaximumDashboardLayoutColumns(code),
        );
    }

    isDashboardLayoutSelected(code: string, columns: number): boolean {
        return this.getDashboardLayoutColumns(code) === columns;
    }

    getDashboardLayoutOptions(item: DashboardPermissionItem): DashboardLayoutOption[] {
        const maximumColumns = this.getMaximumDashboardLayoutColumns(item.code);

        return this.dashboardLayoutOptions.filter(
            (option) => option.columns <= maximumColumns,
        );
    }

    setDashboardLayoutColumns(code: string, columns: number): void {
        if (this.dashboardPreferencesSaving) {
            return;
        }

        this.dashboardLayoutDraftByTabCode[this.currentDashboardTabCode] = {
            ...this.dashboardLayoutDraft,
            [code]: Math.min(
                this.normalizeDashboardLayoutColumn(columns),
                this.getMaximumDashboardLayoutColumns(code),
            ),
        };
    }

    private getDashboardLayoutColumnsPayload(): Record<string, number> {
        this.ensureDashboardLayoutDraft();

        return this.availableDashboardPermissions.reduce<Record<string, number>>(
            (acc, item) => ({
                ...acc,
                [item.code]: this.getDashboardLayoutColumns(item.code),
            }),
            {},
        );
    }

    private ensureDashboardLayoutDraft(): void {
        const permittedCodes = this.availableDashboardPermissions.map(
            (item) => item.code,
        );

        this.dashboardLayoutDraftByTabCode[this.currentDashboardTabCode] =
            this.normalizeDashboardLayoutColumns(
                this.dashboardLayoutDraft,
                permittedCodes,
            );
    }

    private normalizeDashboardLayoutColumns(
        value: any,
        permittedCodes: string[],
    ): Record<string, number> {
        const layoutColumnsByCode: Record<string, number> = {};

        permittedCodes.forEach((code) => {
            layoutColumnsByCode[code] = this.normalizeDashboardLayoutColumn(
                value?.[code],
            );
        });

        return layoutColumnsByCode;
    }

    private normalizeDashboardLayoutColumn(value: any): number {
        const columns = Number(value);

        if (!Number.isFinite(columns)) {
            return 1;
        }

        return Math.max(1, Math.min(Math.round(columns), 4));
    }

    private getMaximumDashboardLayoutColumns(code: string): number {
        const viewportMaximum = this.isHdDashboardViewport() ? 2 : 3;

        if (code === "dashboards-billing-control-production-insurance") {
            return 1;
        }

        return viewportMaximum;
    }

    private isHdDashboardViewport(): boolean {
        return typeof window !== "undefined" && window.innerWidth <= 1366;
    }

    getDashboardPreferenceSummary(): string {
        const selectedCount = this.dashboardPreferenceSelection.length;
        const totalCount = this.availableDashboardPermissions.length;

        if (!totalCount) {
            return "Nenhum dashboard disponível";
        }

        if (selectedCount === totalCount) {
            return "Todos os dashboards da aba";
        }

        return `${selectedCount} de ${totalCount} dashboard(s)`;
    }

    get currentDashboardTabName(): string {
        const tab = (this.tabDashboardList || []).find(
            (item) => item.code === this.currentDashboardTabCode,
        );

        return tab?.name || "aba atual";
    }

    trackDashboardTabByCode(index: number, tab: any): string {
        return tab?.code || `${index}`;
    }

    private getResponsePayload(response: any): any {
        return response?.body?.data || response?.body || {};
    }

    getTabIcon(code: string): string {
        return this.dashboardTabConfigByCode[code]?.icon || "dashboard";
    }
}

export class OnlineUsersDataSource extends DataSource<any> {
    public _filteredDataChange = new BehaviorSubject(false);
    public data: any;
    public qtd: number;

    constructor(
        public adminService: DashboardAdminService,
        public refresh: BehaviorSubject<any>,
    ) {
        super();

        this.data = this.adminService.users;
    }

    connect(): Observable<any[]> {
        const displayDataChanges = [
            this.adminService.onDataChanged,
            this.refresh,
        ];

        return merge(...displayDataChanges).pipe(
            map(() => {
                setTimeout(() => {
                    this.adminService.getUsers().then((res) => {
                        this.data = res.body;
                    });
                }, 6000);
                return this.data;
            }),
        );
    }

    disconnect(): void {}
}
